import Calendar from './calendar/default.svg';
import Campaign from './campaign/default.svg';
import Dashboard from './dashboard/default.svg';
import Funnel from './funnel/default.svg';
import Insights from './insights/default.svg';
import Pixelmanager from './pixelmanager/default.svg';
import Popunder from './popunder/default.svg';
import Programmatic from './programmatic/default.svg';
import SocialMedia from './social media/default.svg';
import VirtualLED from './virtual LED/default.svg';
import CampaignDashboard from './analytics/campaign-dashboard.svg';
import McCampaignDashboard from './analytics/mc-campaign-dashboard.svg';
import ConversionReports from './analytics/conversion-reports.svg';
import ReportingStudio from './analytics/reporting-studio.svg';
import DynamicDisplay from './dinamicDisplay/default.svg';
import MTA from './mta/default.svg';

export default {
    Calendar,
    Campaign,
    Dashboard,
    Funnel,
    Insights,
    Pixelmanager,
    Popunder,
    Programmatic,
    SocialMedia,
    VirtualLED,
    CampaignDashboard,
    McCampaignDashboard,
    ConversionReports,
    ReportingStudio,
    DynamicDisplay,
    MTA,
};
